import React from 'react';
import MapsApiProvider from './MapsApiProvider';
import FormInputPlaces from './FormInputPlaces';
import * as constants from '../../../constants/ParamountReactConstants';

type AutoFillAddressProps = {
  handleAddressChange: (addressComponents: any) => void;
};

const AutoFillAddress: React.FC<AutoFillAddressProps> = ({ handleAddressChange }) => {
  return (
    <MapsApiProvider apiKey={constants.keys.googleMaps.api_key}>
      <FormInputPlaces name="address_1" handleAddressChange={handleAddressChange} />
    </MapsApiProvider>
  );
};

export default React.memo(AutoFillAddress);
